import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/myTrips';
import { loadMore } from './utils';

export default function* listenLoadMore() {
  yield takeEvery(actionTypes.loadMore.toString(), loadMore);
}
